module.exports = __webpack_public_path__ + "img/skybox-picnic.2cf3b0c5.jpg";